import {
    CREATE_POLL_DIALOG_HIDE,
    CREATE_POLL_DIALOG_SHOW,
    EXCLUDE_INFO_SET,
    INCLUDE_INFO_SET,
    POLL_DESCRIPTION_SET,
    POLL_END_DATE_SET,
    POLL_OPTION_SET,
    POLL_OPTIONS_SET,
    POLL_QUESTION_SET,
    POLL_START_DATE_SET,
} from '../constants/polls';

export const showCreatePollDialog = () => {
    return {
        type: CREATE_POLL_DIALOG_SHOW,
    };
};

export const hideCreatePollDialog = () => {
    return {
        type: CREATE_POLL_DIALOG_HIDE,
    };
};

export const setPollOption = (value) => {
    return {
        type: POLL_OPTION_SET,
        value,
    };
};

export const setPollQuestion = (value) => {
    return {
        type: POLL_QUESTION_SET,
        value,
    };
};

export const setPollDescription = (value) => {
    return {
        type: POLL_DESCRIPTION_SET,
        value,
    };
};

export const setPollOptions = (value) => {
    return {
        type: POLL_OPTIONS_SET,
        value,
    };
};

export const setIncludeInfo = (value) => {
    return {
        type: INCLUDE_INFO_SET,
        value,
    };
};

export const setExcludeInfo = (value) => {
    return {
        type: EXCLUDE_INFO_SET,
        value,
    };
};

export const setPollStartDate = (value) => {
    return {
        type: POLL_START_DATE_SET,
        value,
    };
};

export const setPollEndDate = (value) => {
    return {
        type: POLL_END_DATE_SET,
        value,
    };
};
